<template>
  <div 
    :class="`${element.isLock ? 'wrap' : 'wrap cursor'} ${element.compData.type}-theme-${element.compData.styleId}`"
    :style="{...getStyles({...element.compData.styles, wrapWidth: element.boxStyle.width, wrapHeight: element.boxStyle.height})}"
  >
   <AnimatedNumber class="numberInfo" :value="element.compData.num" :duration="element.compData.duration" :formatValue="formatNums"> </AnimatedNumber>
  </div>
</template>

<script>
import AnimatedNumber from 'animated-number-vue'

export default {
  name: "animatedNumberElement",
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return Object.assign(res, {
        opacity: this.element["opacity"] / 100
      })
    },
    formatNums(value) {
      let num = this.element.compData.point || 0
      return `${Number(value).toFixed(num)}`
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.loading = false
    })
  },
  components: {
    AnimatedNumber
  }
};
</script>

<style lang='less' scoped>
.wrap {
  width: 100%;
  height: 100%;
  /deep/ .numberInfo{
      color: var(--color);
      font-size: var(--fontSize);
      font-weight: var(--fontWeight);
      font-family: var(--fontFamily);
    }
  }

</style>
